import noSearchResults from "../resources/img/no-search-results.png";

const imagePaths = {
  noSearchResults,
};

export default imagePaths;
